import { __decorate } from "tslib";
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getAllTaskList } from '@blade-sxp/file-cluster/api/statistics/index';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import taskSelector from '@blade-sxp/file-cluster/components/task-selector.vue';
import authItem from '@blade/common/components/auth/auth-item.vue';
import commomList from '@blade-sxp/file-cluster/pages/create-task/components/common-table.vue';
import { getTaskList } from '@blade-sxp/file-cluster/api/off-duty-detection/index';
import datePicker from '@blade/common/components/date-time-select/index.vue';
let TaskList = class TaskList extends Vue {
    permissions = [];
    form = {
        keyword: '',
        dateRange: [],
        device: [],
        taskList: [],
    };
    dateRange = ['', ''];
    taskStatus = '';
    zoneId = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    pageOrderList = [
        {
            orderField: 'create_time',
            orderType: 'DESC',
        },
    ];
    data = [];
    devices = [];
    activeTask = '';
    dialogVisible = false;
    copyValue = '';
    loading = false;
    defaultTime = ['00:00:00', '23:59:59'];
    taskList = [];
    clusterTaskList = [];
    libraryList = [];
    clusterCard = [
        {
            name: this.$t('cluster'),
            key: 'REALTIME_CLUSTER',
            code: '0309',
            icon: '',
        },
    ];
    listCard = [
        {
            name: this.$t('cluster'),
            key: 'CLUSTER',
            cardType: 'clusterCard',
            cardList: this.clusterCard,
        },
    ];
    get pickerOptions() {
        return {
            shortcuts: [
                {
                    text: this.$t('week'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    },
                },
                {
                    text: this.$t('halfMonth'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                        picker.$emit('pick', [start, end]);
                    },
                },
            ],
            disabledDate: (date) => moment(date).subtract(1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
        };
    }
    onConditionUpdate(form) {
        this.pagination.page = 1;
        this.getTaskList();
    }
    created() {
        this.initActiveTask();
    }
    mounted() {
        this.getTaskList();
    }
    initActiveTask() {
        const cardType = this.listCard[0]?.cardType ?? '';
        this.activeTask = this?.[cardType]?.[0]?.key ?? '';
    }
    getTaskList() {
        this.data = [];
        this.loading = true;
        if (!this.form.dateRange || this.form.dateRange?.length === 0) {
            this.dateRange = ['', ''];
        }
        else {
            this.dateRange = this.form.dateRange;
        }
        const reqParam = {
            taskTypes: [this.activeTask],
            page: this.pagination.page,
            size: this.pagination.size,
            dateEnd: this.dateRange[1],
            dateStart: this.dateRange[0],
            pageOrderList: this.pageOrderList,
            deviceIds: this.form.device,
            keyword: this.form.keyword,
            clusterTaskList: this.form.taskList,
            zoneId: this.zoneId,
            taskStatus: this.taskStatus,
        };
        getTaskList(reqParam)
            .then(async (res) => {
            this.data = res.list ?? [];
            for (let value of this.data) {
                let res = new Map();
                value.zoneInfoVos =
                    value.zoneInfoVos?.filter((zoneInfoVosItem) => !res.has(zoneInfoVosItem.zoneId) && res.set(zoneInfoVosItem.zoneId, 1)) || [];
                value.deviceInfoVos =
                    value.deviceInfoVos?.filter((eviceInfoVosItem) => !res.has(eviceInfoVosItem.deviceId) && res.set(eviceInfoVosItem.deviceId, 1)) || [];
                if (value.bigDataConfig) {
                    value.clusterTaskList = this.clusterTaskList.filter((el) => {
                        return value.bigDataConfig.clusterTaskList.indexOf(el.id) !== -1;
                    });
                    value.pushLibrary =
                        value.bigDataConfig.ruleList.map((rule) => {
                            return this.libraryList.list.find((lib) => {
                                return lib.libId === rule.pushLibrary;
                            });
                        }) || [];
                }
                if (value.alarmConfig) {
                    const { thresholdConfigs } = value.alarmConfig;
                    const { effectivePeriod, effectiveTimes, effectiveDates, dayOfWeeks } = thresholdConfigs[0];
                    value.effectivePeriod = effectivePeriod;
                    value.effectiveTimes = effectiveTimes;
                    value.effectiveDates = effectiveDates;
                    value.dayOfWeeks = dayOfWeeks;
                }
            }
            this.pagination.total = res.total;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    activated() {
        this.pagination.page = 1;
        this.getTaskList();
    }
    refresh() {
        this.pagination.page = 1;
        this.getTaskList();
    }
    changeParam(type, value) {
        switch (type) {
            case 'size':
                this.pagination.size = Number(value);
                break;
            case 'current':
                this.pagination.page = Number(value);
                break;
            case 'zoneId':
                this.pagination.page = 1;
                this.zoneId = String(value);
                break;
            case 'taskStatus':
                this.pagination.page = 1;
                this.taskStatus = String(value);
                break;
            case 'sort':
                this.pageOrderList[0].orderType = String(value);
                break;
            default:
                break;
        }
        this.getTaskList();
    }
    newTask(command) {
        this.taskTypeToPath('add');
    }
    goPage(id, type) {
        this.taskTypeToPath(type, id);
    }
    taskTypeToPath(type, id) {
        const taskType = this.activeTask;
        let path = '';
        if (taskType) {
            path = '/fileCluster/clustering';
            const query = id
                ? {
                    type: type,
                    taskType,
                    id: String(id),
                }
                : {
                    type: type,
                    taskType,
                };
            this.$router.push({ path, query });
        }
    }
    handleReset() {
        this.form = {
            keyword: '',
            dateRange: [],
            device: [],
            taskList: [],
        };
    }
    getAllTaskList() {
        this.loading = true;
        const data = {
            taskTypes: [this.activeTask],
        };
        getAllTaskList(data)
            .then((resp) => {
            this.taskList = JSON.parse(JSON.stringify(resp));
        })
            .finally(() => {
            this.loading = false;
        });
    }
    handleClusterResult(id, type, ...rest) {
        this.$router.push({
            path: '/fileCluster/task-result',
            query: {
                type: 'look',
                taskType: type,
                id: String(id),
                name: encodeURIComponent(rest[0].name),
            },
        });
    }
};
__decorate([
    Watch('form', { deep: true, immediate: false })
], TaskList.prototype, "onConditionUpdate", null);
TaskList = __decorate([
    Component({
        name: 'TaskList',
        components: { commomList, deviceSelect, authItem, taskSelector, datePicker },
        i18n: {
            messages: {
                en: {
                    inputHolder: 'Task Name/Creator ',
                    start: 'Start date',
                    end: 'End date',
                    week: 'Last week',
                    halfMonth: 'Last 15 days',
                    crowd: 'Crowd and Individual',
                    face: 'Face',
                    human: 'Body',
                    vehicl: 'Vehicle',
                    faceRatio: 'Face Comparison',
                    faceRecognition: 'Face Attribute Recognition',
                    faceCombination: 'Face&Body Recognition',
                    humanRecognition: 'Body Attribute Recognition',
                    vehicleRecognition: 'Vehicle Attribute Recognition',
                    queue: 'Queue Management',
                    crowdCount: 'Crowd Counting',
                    staffLeave: 'Unauthorized Leave',
                    newTask: 'New Task',
                    copyTask: 'Copy Task',
                    reset: 'Reset',
                    task: 'Task',
                    choose: 'Select',
                    device: 'Device',
                    crowdDetention: 'Crowd Retention',
                    crowdCountercurrent: 'Crowd Counterflow',
                    crowdInvasion: 'Crowd Intrusion',
                    socialDistance: 'Close Social Distance',
                    crowdGatheredAndDispersed: 'Crowd Gather and Dispersion',
                    crowdDensity: 'Crowd Density',
                    cluster: 'Clustering File',
                    bigdata: 'Big Data',
                },
                zh: {
                    inputHolder: '请输入任务名称/创建人',
                    start: '开始',
                    end: '结束',
                    week: '近一周',
                    halfMonth: '近15天',
                    crowd: '人群任务',
                    face: '人脸任务',
                    human: '人体任务',
                    vehicl: '车辆任务',
                    queue: '排队管理',
                    faceRatio: '人脸比对',
                    faceRecognition: '人脸属性识别',
                    faceCombination: '人脸&人体联合',
                    humanRecognition: '人体属性识别',
                    vehicleRecognition: '车辆属性识别',
                    crowdCount: '人群统计',
                    staffLeave: '人员离岗',
                    newTask: '创建任务',
                    copyTask: '复制任务',
                    reset: '重置',
                    task: '任务',
                    choose: '请选择',
                    device: '设备',
                    crowdDetention: '人群滞留',
                    crowdCountercurrent: '人群逆流',
                    crowdInvasion: '人群入侵',
                    socialDistance: '社交距离',
                    crowdGatheredAndDispersed: '人群聚集分散',
                    crowdDensity: '人群密度',
                    cluster: '聚档',
                    bigdata: '大数据',
                },
            },
        },
    })
], TaskList);
export default TaskList;
